
/**
 * Utility to export JSON data to CSV (Excel compatible)
 */
export const exportToCSV = (data, headers, filename) => {
  if (!data || !data.length) return;

  const csvContent = [
    headers.join(','),
    ...data.map(row => 
      headers.map((header, index) => {
        let val = '';
        if (typeof header === 'object' && header.getter) {
            val = header.getter(row);
        } else {
            val = Array.isArray(row) ? row[index] : row[header];
        }
        
        const stringVal = val === null || val === undefined ? '' : String(val);
        const escaped = stringVal.replace(/"/g, '""');
        return escaped.includes(',') || escaped.includes('\n') || escaped.includes('"') 
          ? `"${escaped}"` 
          : escaped;
      }).join(',')
    )
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportToPDF = () => {
  window.print();
};
